import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import { InactivityDetectorWrapper as EmotionInactivityDetectorWrapper } from './styled-emotion';
import { InactivityDetectorWrapper as CompiledInactivityDetectorWrapper } from './styled-compiled';
import { fg } from '@atlaskit/platform-feature-flags';
export var InactivityDetectorWrapper = /*#__PURE__*/forwardRef(function (props, ref) {
  return fg('platform_media_compiled') ? /*#__PURE__*/React.createElement(CompiledInactivityDetectorWrapper, _extends({}, props, {
    ref: ref
  })) : /*#__PURE__*/React.createElement(EmotionInactivityDetectorWrapper, _extends({}, props, {
    ref: ref
  }));
});